var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./~/reactcss/~/lodash/_Uint8Array.js
// module id = 656
// module chunks = 0